import React from 'react'
import { createPortal } from 'react-dom'

function TopSuccess({ children }) {
    return createPortal(children , document.getElementById('topMessage')

    );
}

export default TopSuccess;
